import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDepartmentsStart } from "../../redux/departments/reducer";
import { selectDepartments , departmentsLoading} from "../../redux/departments/selectors";
import usePaginationWrapper from "../general/usePaginationWrapper";

const useDepartmentsGet = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(departmentsLoading);
  const departments = useSelector(selectDepartments);

  const [fetch, setFetch] = useState(0);

  const {
    limit,
    offset,
    setOffset,
    setLimit,
    totalElements,
    totalPages,
    numberOfElements,
    setPageable,
    page,
    setPage,
    pageOptions,
    searchText,
    debouncedSearchText,
    setSearchText,
  } = usePaginationWrapper({ defaultLimit: 10 });

  const refetch = useCallback(() => setFetch((prev) => prev + 1), []);

  const fetchDepartments = useCallback(() => {
    dispatch(
      getDepartmentsStart({
        keyword: debouncedSearchText,
        size: limit,
        page: (page - 1),
      })
    );
  }, [dispatch, page, limit, debouncedSearchText]);

  useEffect(() => {
    fetchDepartments();
  }, [fetchDepartments, fetch]);

  useEffect(() => {
    if (departments) {
      setPageable({
        total_elements: departments?.count,
        total_pages: departments?.pages,
        number_of_elements: departments?.items?.length,
      });
    }
  }, [departments, setPageable]);

  return {
    departments,
    loadingDepartments: isLoading,
    refetch,
    limit,
    offset,
    setOffset,
    setLimit,
    totalElements,
    totalPages,
    numberOfElements,
    page,
    setPage,
    pageOptions,
    searchText,
    debouncedSearchText,
    setSearchText,
  };
};

export default useDepartmentsGet;
